export default __webpack_public_path__ + "7a4647fb5f4d03fafdb9891c0d793e58.png";